import { Link } from 'react-router-dom';
import HubspotForm from 'react-hubspot-form'

const scrollTo = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({
        behavior: "smooth",
    });
};

const HeroSection = () => {
    return (
        <>
            <section className="slider__area">
                <div className="single-slider d-flex align-items-center pt-80 pb-80" style={{
                    background: `url(assets/img/hero-img1.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover'
                }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="slider__content text-start mb-lg-0 mb-40">
                                    <h1>Smart Learning for Brighter Tomorrow</h1>
                                    <p>Education is evolving, and smart learning solutions are paving the way for a brighter, more connected future. By integrating technology with personalized learning experiences, students gain access to interactive tools, real-time feedback, and engaging content that make knowledge more impactful and accessible.</p>
                                    <p>This modern approach not only strengthens academic growth but also nurtures creativity, critical thinking, and lifelong skills-empowering learners to succeed in tomorrow’s world.</p>
                                    <div className="slider__btn mt-40">
                                        <Link to="/" className="z-btn z-btn-white" onClick={() => scrollTo("contact")}>
                                            Request for Free Demo
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 offset-lg-1">
                                <div className="slider__content">
                                    <div className="contact__head">
                                        <h4>Kickstart Your E-Learning Solutions Today!</h4>
                                    </div>
                                    <div className="contact__wrapper">
                                        <HubspotForm
                                            portalId='7805960'
                                            formId='59a125d5-7f2c-4e20-8b05-6ed85ce116e9'
                                            onSubmit={() => console.log('Submit!')}
                                            onReady={(form) => console.log('Form ready!')}
                                            loading={<div>Loading...</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeroSection;